import * as React from "react";
import { forwardRef } from "react";
const SvgWonder = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#94A3B8", fillRule: "evenodd", d: "M14.402 8a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0Zm-6.4-2.4a.8.8 0 0 0-.694.4.8.8 0 0 1-1.385-.8 2.4 2.4 0 1 1 2.879 3.464V8.8a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8.8.8 0 1 0 0-1.6Zm0 6.4a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgWonder);
export { ForwardRef as ReactComponent };
